import React from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { RATE_BROWSER } from '../../../../constants/fulfillment-plan-ids';
import { RateBrowserAdapterForFulfillmentPlannerContext } from '../../../../fulfillment-planner';
import Global from '../../../../store/global-selectors';
import CreateLabelContent from '../../../create-label-content';
import { RATE_BROWSER as RATE_BROWSER_NAME } from '../../../../constants/component-names';

const shipToSelector = createSelector(
  (shipToPostalCode) => shipToPostalCode,
  (_, shipToCountryCode) => shipToCountryCode,
  (_, __, shipToCity) => shipToCity,
  (shipToPostalCode, shipToCountryCode, shipToCity) => {
    return {
      postalCode: shipToPostalCode,
      countryCode: shipToCountryCode,
      city: shipToCity,
      name: '',
      line1: '',
      line2: '',
      line3: null,
      state: '',
      company: '',
      phone: '',
    };
  },
);

export const RateBrowserAdapterWrapper = () => {
  const address = useSelector((state) => {
    const ratesModel = Global.selectRateBrowsergetConfigureRatesModel(state);
    const { shipToPostalCode, shipToCountryCode, shipToCity } = ratesModel;
    return shipToSelector(shipToPostalCode, shipToCountryCode, shipToCity);
  });

  return (
    <RateBrowserAdapterForFulfillmentPlannerContext
      key={RATE_BROWSER}
      fulfillmentPlanId={RATE_BROWSER}
      initialShipTo={address}
      parentComponentName={RATE_BROWSER_NAME}
    >
      <CreateLabelContent fulfillmentPlanId={RATE_BROWSER} shouldShowBackButton />
    </RateBrowserAdapterForFulfillmentPlannerContext>
  );
};
